import { Injectable } from '@angular/core';
import { MatDatepickerIntl } from '@angular/material/datepicker';

@Injectable()
export class CustomDatepickerIntl extends MatDatepickerIntl {
  nextMonthLabel = '';
  prevMonthLabel = '';
  nextYearLabel = '';
  prevYearLabel = '';
  nextMultiYearLabel = '';
  prevMultiYearLabel = '';
  switchToMonthViewLabel = '';
  switchToMultiYearViewLabel = '';
  cancelLabel = '';
  setLabel = '';
  doneLabel = '';
  clearLabel = '';
}

